import {
    firebaseFire as Libfirebase,
} from "../helpers/firebase-config.js";

// CONSORCIOS - DEPOIS VER DE TIRAR DAQUI
export async function getAssistentes(medico) {
    const assistentes = await Libfirebase.collection("usuario").doc(medico).collection("assistentes").get()

    return assistentes.docs.map((doc) => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}

// export async function getConsorcioById(id) {
//     const doc = await Libfirebase.collection("consorcios").doc(id).get()
//     return {
//         id: doc.id,
//         ref: doc.ref,
//         ...doc.data(),
//     }
// }

export async function saveAssistente(assistente, doc) {
    console.log(doc)
    console.log(assistente)
    return Libfirebase.collection("usuario").doc(doc).collection("assistentes").add(assistente)
}

export async function getProfissionais() {
    const profs = await Libfirebase.collection("usuario")
        .where('profissao', '!=', 'Paciente')
        .get()

    return profs.docs.map((doc) => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}

export async function getProfByAssistente(assistenteCpf) {
    const assists = await Libfirebase.collectionGroup("assistentes").where("cpf", "==", assistenteCpf).get()

    let profsPromise = []
    assists.docs.map((doc) => {
        profsPromise.push(doc.ref.parent.parent.get())
    })
    const profs = await Promise.all(profsPromise)
    return profs.map((doc) => {
        return {
            id: doc.id,
            ref: doc.ref,
            ...doc.data(),
        }
    })
}